import { Component, OnInit } from '@angular/core';
import { Localiser } from '../../services/localiser';
import { Navigation } from '../../services/navigation.service';
import { UserService } from '../../services/user.service';
import { EnvService } from 'src/app/services/env.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  email: string = "";
  password: string = "";

  chargingLogin: boolean = false;
  feedbackLogin: number = 0;

  constructor(public localiser: Localiser, private navigation: Navigation, private user: UserService, private envService: EnvService) { }

  ngOnInit(): void {
    console.log(`INIT LOGIN ATENEA develop/25-09-2026`);

    this.user.getLoginError().subscribe(next => {
      this.feedbackLogin = <number>next;
      if (this.feedbackLogin != 0) {
        this.chargingLogin = false;
      }
    });
  }

  changeLanguage(language) {
    if (language == "English") {
      this.localiser.load("en");
    } else {
      this.localiser.load("es");
    }
  }

  logIn() {
    this.chargingLogin = true;
    this.user.logIn(this.email, this.password);
   /* if (this.password == 'ateneaweb775') {
      if (this.email == undefined) {
        this.user.logIn('');
      } else {
        this.user.logIn(this.email);
      }
      this.navigation.toHome();
    }
    this.user.logIn(this.email);
    this.navigation.toHome();

    */
  }

  whichMessage() {
    if (this.feedbackLogin == 1) {
      return this.localiser.get("login.loginDoneMessage");
    } else if (this.feedbackLogin == -1) {
      return this.localiser.get("login.loginErrorMessage");
    } else if (this.feedbackLogin == -2) {
      return this.localiser.get("login.loginErrorMessageLicense");
    }
  }

}
